import { render, staticRenderFns } from "./TonalHeader.vue?vue&type=template&id=023476e2&"
import script from "./TonalHeader.vue?vue&type=script&lang=js&"
export * from "./TonalHeader.vue?vue&type=script&lang=js&"
import style0 from "./TonalHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports